export default __webpack_public_path__ + "static/media/Icon awesome-instagram.45b5232f.svg";